if (!customElements.get('custom-modal')) {
  customElements.define(
    'custom-modal',
    class CustomModal extends ModalElement {
      get shouldLock() {
        return true;
      }

      get shouldAppendToBody() {
        return true;
      }

      connectedCallback() {
        super.connectedCallback();

        document.addEventListener('click', (event) => {
          const anchor = event.target.closest('a[href^="#"]');
          if (anchor && anchor.getAttribute('href') === '#' + this.id) {
            event.preventDefault();
            this.show(anchor);
          }
        }, { signal: this.abortController.signal });

        window.addEventListener('hashchange', () => {
          if (window.location.hash === '#' + this.id) {
            this.show();
          }
        }, { signal: this.abortController.signal });

        if (window.location.hash === '#' + this.id) {
          requestAnimationFrame(() => this.show());
        }
      }

      get autoplay() {
        return this.getAttribute('data-autoplay') === 'true';
      }

      afterShow() {
        super.afterShow();
        if (this.autoplay) {
          const video = this.querySelector('video');
          if (video) video.play();
        }
      }

      afterHide() {
        super.afterHide();
        const video = this.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
        if (window.location.hash === '#' + this.id) {
          //Silent -- closing a modal is not a navigation. See snippets/native-history.liquid.
          theme.replaceStateSilent(null, '', window.location.pathname + window.location.search);
        }
      }
    }
  );
}
